import * as React from 'react';
import { Fade } from 'ui/transitions';
import { ErrorMessage } from 'ui/shared/ErrorMessage';

type OwnProps = {
    visible: boolean;
};

const indentedStyle = {
    marginLeft: '1em',
};

export const Required = ({ visible }: OwnProps) =>
    <Fade
        visible={ visible }
        duration={ 200 }
        style={ indentedStyle }
        element="span"
    >
        <ErrorMessage
            textKey="VAL_REQUIRED"
        />
    </Fade>
;



// WEBPACK FOOTER //
// ./src/ui/pages/designer/Required.tsx